// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__iSqjs","body":"style__body__s1fqF","thumbnail":"style__thumbnail__yyGH8","settings":"style__settings__Pb8iD"};